import { render, staticRenderFns } from "./new-tris-scroll-good-billon.vue?vue&type=template&id=0c32365a"
import script from "./new-tris-scroll-good-billon.vue?vue&type=script&lang=js"
export * from "./new-tris-scroll-good-billon.vue?vue&type=script&lang=js"
import style0 from "./new-tris-scroll-good-billon.vue?vue&type=style&index=0&id=0c32365a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports